import { render, staticRenderFns } from "./history_former.vue?vue&type=template&id=7a2d93be&"
import script from "./history_former.vue?vue&type=script&lang=js&"
export * from "./history_former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports